<!-- <div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Implement Action</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <mat-radio-group name="type" [(ngModel)]="actionType">
                <mat-radio-button labelPosition="before" value="1" title="Replace" #actReplace (click)="doReplace()">Replace</mat-radio-button>
                <mat-radio-button labelPosition="before" value="2" title="Repair" #actRepair (click)="doRepair()">Repair</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="input-container">
            <span class="label">Implement</span>
            <select (change)="implementSelected($event.target.value)" style="height: 40px;display: inline !important; background-color: #F4F7FA;
            color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;">
                <option value="" disabled selected>Select Implement</option>
                <option *ngFor="let implement of implementList" [value]="implement.Id">{{implement.Name}}</option>
            </select>
        </div>
        <div class="input-container">
            <span class="label">Component</span>
            <select (change)="componentSelected($event.target.value)" style="height: 40px;display: inline !important; background-color: #F4F7FA;
            color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;">
                <option value="" disabled selected>Select Component</option>
                <option *ngFor="let component of componentList" [value]="component.Id">{{component.Name}}</option>
            </select>
        </div>
        <div class="input-container" *ngIf="equipmentId>0">
            <span class="label">SMU</span>
            <input type="number"  min="0" [(ngModel)]="currentSmu" (ngModelChange)="smuChange()" step="any" style="height: 40px;display: inline !important; background-color: #F4F7FA;
            color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;">
        </div>

        <div class="input-container" *ngIf="actionType==1">
            <span class="label">Down time Hours</span>
            <span class="input-icon" style="padding: 12px 16px; background: #E4EAF0;font-size: 14px;">Hrs</span>
            <input type="number" style="min-width: 246px" value="0.00" min="0" [(ngModel)]="downtimeHrs" (ngModelChange)="downtimeHrsChanged()" step="any" class="get-Input-cost">
        </div>

        <div class="input-container">
            <span class="label">Cost</span>
            <span class="input-icon" style="padding: 12px 16px;
            background: #E4EAF0;
            font-size: 14px;">$</span>
            <input type="number" value="0.00" min="0" [(ngModel)]="cost" (ngModelChange)="costChanged()" step="any" class="get-Input-cost">
        </div>
        <div class="input-container">
            <span class="label">Date</span>
            <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()" matTooltip="{{ttDate}}" style="padding: 7px 16px;
            background: #E4EAF0;
            font-size: 14px;">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker" class="get-Input-date"
                   [min]="minDateForAction" [max]="maxDateForAction" placeholder="Choose a date"
                   [(ngModel)]="eventDate" (ngModelChange)="dateChanged()"
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>
        <div style="margin-bottom: 16px;margin-left: 8px;">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()" class="textAreaComment">
                  placeholder="Enter a comment about this repair. "
                  matTooltip="{{ttComment}}"></textarea>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div> -->

<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Asset Repair - Multiple Components</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
    <!-- <div class="input-container">
        <mat-radio-group name="type" [(ngModel)]="actionType">
            <mat-radio-button labelPosition="before" value="1" title="Replace" #actReplace (click)="doReplace()">Replace</mat-radio-button>
            <mat-radio-button labelPosition="before" value="2" title="Repair" #actRepair (click)="doRepair()">Repair</mat-radio-button>
        </mat-radio-group>
    </div> -->
    <div style="display: flex; flex-direction: row;">
      <div class="input-container">
        <span class="label">Select Implement</span>
        <!-- <mat-select  (change)="implementSelected($event.target.value)"  style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px; " [(ngModel)]="selectedImplement">
            <mat-option value="" disabled selected>Select Implement</mat-option>
            <mat-option *ngFor="let implement of implementList" [value]="implement.Id">{{implement.Name}}</mat-option>
        </mat-select > -->
        <!-- <mat-select placeholder="Select Implment"style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;"  [(ngModel)]="selectedImplement" >
            <mat-option *ngFor="let implement of implementList" [value]="implement.Id" >
              {{implement.Name}}
            </mat-option>
          </mat-select> -->


        <mat-select [(ngModel)]="selectedImplement" (selectionChange)="implementSelected()" style="height: 40px;display: inline !important; background-color: #F4F7FA;
                    color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;"
          placeholder="{{ 'Select Implement' | translate | async}}">
          <mat-option *ngFor="let implement of implementList" [value]="implement.Id">
            {{implement.Name}}
          </mat-option>
        </mat-select>

      </div>
      <div class="input-container" style="margin-bottom: 1%;">
        <span class="label">Select Component Type</span>
        <!--<mat-select placeholder="Select Component Type" style="height: 40px;display: inline !important; background-color: #F4F7FA;
          color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;" [(ngModel)]="selectedComponentType"
              multiple>
    <mat-option *ngFor="let type of componentTypes" [value]="type.Id" (click)="ChangecomponentType()">
      {{type.Name}}
    </mat-option>
  </mat-select>-->

        <mat-select placeholder="Select Component Type" [(ngModel)]="selectedComponentType" multiple
          (ngModelChange)="ChangecomponentType($event)"
          style="height: 40px; display: inline !important; background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;">
          <mat-option *ngFor="let type of componentTypes" [value]="type.Id">
            {{ type.Name }}
          </mat-option>
        </mat-select>

      </div>

      <div style="display:flex;align-items:center;margin-left:10px;" *ngIf="isPendingAssetActions">
        <mat-checkbox [(ngModel)]="removeActionData" (change)="onRemoveActionDataChanged($event)">
          Remove Action Data
        </mat-checkbox>
      </div>

    </div>
    <div style="display: flex; flex-direction: row;justify-content: space-between;">
      <div class="input-container">
        <span class="label">Date</span>
        <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()" matTooltip="{{ttDate}}" style="padding: 7px 16px;
                background: #E4EAF0;
                font-size: 14px;">
          <i class="material-icons">date_range</i>
        </span>
        <input type="text" [matDatepicker]="picker" class="get-Input-date" [max]="maxDateForAction"
          placeholder="Choose a date" [(ngModel)]="eventDate" (ngModelChange)="dateChanged()" readonly="readonly"
          style="color: black">
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="input-container" *ngIf="equipmentId>0">
        <span class="label" style="width: 165px;">SMU</span>
        <input type="number" min="0" [(ngModel)]="currentSmu" (ngModelChange)="smuChange()" step="any" style="height: 40px;
                display: inline !important; background-color: #F4F7FA;
                color: #1D2F36; min-height: 40px; padding: 10px;">
      </div>

      <div class="input-container" style="margin-bottom: 16px ;">
        <span class="label">Down time Hours</span>
        <span class="input-icon" style="padding: 12px 16px; background: #E4EAF0;font-size: 14px;">Hrs</span>
        <input type="number" style="min-width: 100px" value="0.00" min="0" [(ngModel)]="downtimeHrs"
          (ngModelChange)="downtimeHrsChanged()" step="any" class="get-Input-cost">
      </div>


    </div>
    <div style="display: flex;flex-direction: column;justify-content: space-between;">
      <div class="input-container" style="margin-bottom: 16px ; margin-left: 193px;">
        <span class="label">Labour Hrs: {{totalHrs}}</span>
        <span class="label">Labour : $ {{totalLabour| number: '1.'}}</span>
        <span class="label">Parts : $ {{totalparts| number: '1.'}}</span>
        <span class="label">Misc. : $ {{totalMisc| number: '1.'}}</span>
        <span class="label">Total Cost: $ {{totalcost| number: '1.'}}</span>


      </div>
      <div style="border-radius:10px;border: solid; " [ngStyle]="{'border-color':hasDiffernce?'red':'green'}">


        <div class="input-container" style="margin-bottom: 16px ;margin-left: 17%;">
          <span style="    margin-right: 5px;">Total Costs : </span>
          <div style="display:flex; flex-direction: column; ">
            <span class="">Labour Hrs</span>
            <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
              [(ngModel)]="TLabour_Hours" step="any" class="get-Input-cost"
              (focusout)="calculateDifferenceLabourHours()">
          </div>
          <div style="display:flex; flex-direction: column; ">
            <span class="">Labour $ </span>
            <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
              [(ngModel)]="TLabour_Cost" step="any" class="get-Input-cost" (focusout)="calculateDifferenceLabourCost()">
          </div>
          <div style="display:flex; flex-direction: column; ">
            <span class="">PartCost $</span>
            <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
              [(ngModel)]="TPart_Cost" step="any" class="get-Input-cost" (focusout)="calculateDifferencePartCost()">
          </div>
          <div style="display:flex; flex-direction: column; ">
            <span class="">Misc. $ </span>
            <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
              [(ngModel)]="TMisc_Cost" step="any" class="get-Input-cost" (focusout)="calculateDifferenceMiscCost()">
          </div>
        </div>
        <div class="input-container" style="margin-bottom: 16px ; margin-left: 17%;">
          <span style="    margin-right: 51px;">Difference : </span>
          <div style="display:flex; flex-direction: column; ">
            <span class="" style="width: 100px;" [ngStyle]="{'color':DLabour_Hours!=0?'red':'green'}">
              {{DLabour_Hours}}</span>

          </div>
          <div style="display:flex; flex-direction: column; ">
            <span class="" style="width: 100px;" [ngStyle]="{'color':DLabour_Cost!=0?'red':'green'}">{{DLabour_Cost}}
            </span>

          </div>
          <div style="display:flex; flex-direction: column; ">
            <span class="" style="width: 100px;" [ngStyle]="{'color':DPart_Cost!=0?'red':'green'}">{{DPart_Cost}}</span>

          </div>
          <div style="display:flex; flex-direction: column; ">
            <span class="" style="width: 100px;" [ngStyle]="{'color':DMisc_Cost!=0?'red':'green'}">{{DMisc_Cost}}
            </span>

          </div>
        </div>
      </div>

    </div>
    <div style="overflow-y: auto; height:350px; ">
      <table class="table table--striped table--full-width">
        <thead>
          <th style="padding: 1px!important;width: 0px;">
            <mat-checkbox color="primary" [(ngModel)]="cbAllComponentSelect"
              (click)="toggleAllObsevations(!cbAllComponentSelect)"
              style=" margin-right: 16px!important;"></mat-checkbox>
          </th>
          <th style="padding: 1px!important;">Component</th>
          <th style="padding: 1px!important;">Action Type</th>
          <th style="padding: 1px!important;">Hrs</th>
          <th style="padding: 1px!important;">Labour $</th>
          <th style="padding: 1px!important;">Parts $</th>
          <th style="padding: 1px!important;">Misc. $</th>
          <th style="padding: 1px!important;">Total</th>
          <th style="padding: 1px!important;">Comment</th>
          <th style="text-align: center;">Planned</th>
          <th></th>
        </thead>
        <tbody>
          <ng-container *ngIf="componentList!=null && selectedComponentType!=null">

            <tr *ngFor="let comp of componentList; trackBy: trackById"
              [ngClass]="{'ErrorAction': comp.ActionSucess==2}">
              <td>
                <mat-checkbox id="chkComponent-{{comp.Id}}" [checked]="comp.selectComp" [value]="comp.Id"
                  style="margin-left: 16px!important; margin-right: 16px!important;" color="primary"
                  (change)="onComponentListControlChanged(comp.Id, comp.Name,comp)">
                </mat-checkbox>
              </td>
              <td style="padding: 1px!important;">{{comp.Name}}</td>
              <td style="padding: 1px!important;">
                <mat-form-field style="max-width: 100px;">
                  <mat-select placeholder="Select Action" [(ngModel)]="comp.ActionId" required>
                    <mat-option [value]="1">Replace</mat-option>
                    <mat-option [value]="2">Repair</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0" min="0"
                  [(ngModel)]="comp.LabourHrs" step="any" class="get-Input-cost" (focusout)="calculateTotalHrs()">
              </td>
              <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
                  [(ngModel)]="comp.LabourCost" step="any" class="get-Input-cost" (focusout)="calculateTotalCost(comp)">
              </td>
              <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
                  [(ngModel)]="comp.PartCost" step="any" class="get-Input-cost" (focusout)="calculateTotalCost(comp)">
              </td>
              <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                <input style="min-width: 0px !important;max-width: 100px;" type="number" value="0.00" min="0"
                  [(ngModel)]="comp.MiscCost" step="any" class="get-Input-cost" (focusout)="calculateTotalCost(comp)">
              </td>
              <td style="min-width:0px !important;max-width: 135px!important;  padding: 1px!important;">
                <input style="min-width: 0px !important;max-width: 100px;" [disabled]="true" type="number" value="0.00"
                  min="0" [(ngModel)]="comp.cost" step="any" class="get-Input-cost">
              </td>
              <td style="padding: 1px!important;">
                <input rows="4" maxlength="256" [(ngModel)]="comp.comment" class="textAreaComment"
                  style="    min-width: 275px;" placeholder="Enter a comment about this repair." />
              </td>
              <td>
                <mat-checkbox [(ngModel)]="comp.Planned"
                  style="margin-left: 16px!important; margin-right: 16px!important;" color="primary">
                </mat-checkbox>
              </td>
              <td style="width: 17%;">
                <span style="color: red;">{{comp.Error}} <b>{{comp.ActionMinDate|date: 'dd MMM yyyy'}}</b></span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- <div class="input-container">
        <span class="label">Component</span>
        <select (change)="componentSelected($event.target.value)" style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;">
            <option value="" disabled selected>Select Component</option>
            <option *ngFor="let component of componentList" [value]="component.Id">{{component.Name}}</option>
        </select>
    </div>


    <div class="input-container">
        <span class="label">Cost</span>
        <span class="input-icon" style="padding: 12px 16px;
        background: #E4EAF0;
        font-size: 14px;">$</span>
        <input type="number" value="0.00" min="0" [(ngModel)]="cost" (ngModelChange)="costChanged()" step="any" class="get-Input-cost">
    </div>

    <div style="margin-bottom: 16px;margin-left: 8px;">Comment</div>
    <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()" class="textAreaComment">
              placeholder="Enter a comment about this repair. "
              matTooltip="{{ttComment}}"></textarea> -->
  </div>
  <!-- <div class="ttmodal__footer">

      <a class="button button--primary" [class.loading]="savingChanges" [disabled]="DisabledSaveButton" (click)="saveChangesNew()"><span class="button__text">Save</span></a>
  </div> -->

  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
    <button mat-raised-button color="warn" [class.loading]="savingChanges" [disabled]="DisabledSaveButton"
      (click)="saveChangesNew()">
      <span class="button__text">Save</span>
    </button>
  </div>
</div>